import { extend } from 'vee-validate'
import { required } from 'vee-validate/dist/rules'

// Required rule
extend('required', {
  ...required,
  message: 'To pole jest wymagane'
})
